import React from "react";
import { useTranslation } from "react-i18next";

export default function DailyDataTable({ dailyData }) {
  const { t, i18n } = useTranslation();
  const isLtr = i18n.language === "en";

  return (
    <div className="index-daily-table-wrapper">
      <table
        className="index-daily-table"
        cellSpacing="0"
        rules="all"
        dir="rtl"
      >
        <thead className="index-daily-table-head">
          <tr className="index-daily-table-head-row">
            <td>{t("DailyDataTable.return")}</td>
            <td>{t("DailyDataTable.price")}</td>
            <td>{t("DailyDataTable.date")}</td>
          </tr>
        </thead>
        <tbody>
          {dailyData.map((row, i) => (
            <tr
              key={row.date}
              style={{
                backgroundColor: i % 2 === 1 ? "#F2F2F2" : "",
              }}
            >
              <td style={{ direction: "ltr" }}>
                {row.return?.toFixed(4) || row.return}
              </td>
              <td>{row.price?.toFixed(2)}</td>
              <td>{row.date.split("T")[0]}</td>
            </tr>
          ))}
        </tbody>
      </table>
      <span className="index-daily-table-text" dir={isLtr ? "ltr" : "rtl"}>
        {t("DailyDataTable.rights_reserved")}
      </span>
    </div>
  );
}
